<template>
  <v-app id="root">
    <v-app-bar v-if="!isClienteDeparturesAuth" app dark dense color="primary" class="app-header" elevation="2">
      <v-toolbar-title>
        <v-row class="d-none d-sm-flex">
          <v-col cols="3" class="pt-3">
            <v-img :src="logoHeader" max-height="40" max-width="50" contain />
          </v-col>
          <v-col cols="9" class="pt-4">
            Konect App
            <v-chip color="pinkKonect" small label text class="ver">v{{ version }}</v-chip>
          </v-col>
        </v-row>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-for="urlRoute in urlRoutes" :key="urlRoute.title">
        <span v-if="urlRoute.path == $route.path && havePermission">
          <v-icon aria-hidden="false">{{ urlRoute.icon }}</v-icon>
          <span> {{ urlRoute.title }} </span>
        </span>
      </span>
      <v-spacer></v-spacer>
      <v-menu v-for="item in items" :key="item.path" offset-y>
        <template v-if="checkPermissions(item.per)" v-slot:activator="{ attrs, on }">
          <v-btn color="white" icon dark class="text-user" v-bind="attrs" v-on="on">
            <btnRedirect
              :permission="false"
              actionColor="white"
              :iconName="item.icon"
              :text="item.title"
              :path="item.path"
              type="button"
            />
          </v-btn>
        </template>
        <v-card max-width="25vw" v-if="item.path == ''">
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon right>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ user.name }}</v-list-item-title>
                <v-list-item-subtitle v-for="rol in user.role" :key="rol">{{ rol }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="menu = false">Cancelar</v-btn>
            <v-btn color="error" text @click="logout()">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container fluid class="pa-0" style="height: 100%; display: flex; justify-content: space-around">
        <template v-if="!havePermission">
          <h1 style="align-self: center">Sin acceso - Consulte a su administrador</h1>
        </template>
        <router-view v-else></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { btnRedirect } from '@/components'
import services from '@/utils/services'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'root',
  components: { btnRedirect },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    havePermission: false,
    loading: false,
    menu: null,
    location: window.location.pathname,
    logoHeader: require('@/assets/logo-app.png'),
    logoMenu: require('@/assets/logo.png'),
    urlRoutes: [
      { icon: 'mdi-bus-clock', title: 'Salidas', path: '/client/departures', role: '*' },
      { icon: 'mdi-map', title: 'Mapa', path: '/client/home', role: '*' },
      {
        icon: 'mdi-alert-rhombus-outline',
        title: 'Reporte de incidencias',
        path: '/client/reporteIncidencias',
        role: '*'
      },
      {
        icon: 'mdi-file-chart',
        title: 'Reporte de usuarios',
        path: '/client/reporteUsuarios',
        role: '*'
      },
      {
        icon: 'mdi-bus-alert',
        title: 'Reporte de viajes',
        path: '/client/reporteViajes',
        role: '*'
      },
      {
        icon: 'mdi-account-group',
        title: 'Empleados y rutas',
        path: '/client/EmpleadosYRutas',
        role: '*'
      },
      {
        icon: 'mdi-bus-stop-uncovered',
        title: 'Pasajeros y rutas',
        path: '/client/administracionPasajerosYViajes',
        role: '*'
      },
      {
        icon: 'mdi-bus-multiple',
        title: 'Konect Van Empresarial',
        path: '/konectVan/viajes',
        role: '*'
      },
      {
        icon: 'mdi-bus-multiple',
        title: 'Ascensos',
        path: '/ascensos',
        role: '*'
      },
      {
        icon: 'mdi-clipboard-text-outline',
        title: 'Reporte Regio Ruta',
        path: '/reporteRegioRuta',
        role: '*'
      },
      {
        icon: 'mdi-clipboard-text-multiple-outline',
        title: 'Reporte Regio Ruta Extendido',
        path: '/reporteRegioRutaExtendido',
        role: '*'
      },
      {
        icon: 'mdi-map-clock-outline',
        title: 'Mapa Operativo Regio Ruta',
        path: '/mapaRegioRuta',
        role: '*'
      },
      {
        icon: 'mdi-map-marker-path',
        title: 'Mapa Konect Van Empresarial',
        path: '/konectVan/mapa',
        role: '*'
      },
      {
        icon: 'mdi-qrcode-scan',
        title: 'Konect Van Offline',
        path: '/konectVan/VanOffline',
        role: '*'
      }
    ],
    items: [
      { icon: 'mdi-bus-clock', title: 'Salidas', path: '/client/departures', role: '*', per: 'CLIENTE_KONECT' },
      { icon: 'mdi-map', title: 'Mapa', path: '/client/home', role: '*', per: 'CK_MAPA_LECTURA' },
      {
        icon: 'mdi-file-chart',
        title: 'Reportes',
        path: '/client/reporteUsuarios',
        role: '*',
        per: 'CK_REPORTES_LECTURA'
      },
      {
        icon: 'mdi-account-group',
        title: 'Empleados y rutas',
        path: '/client/EmpleadosYRutas',
        role: '*',
        per: 'CK_EMPLEADOS_LECTURA'
      },
      {
        icon: 'mdi-bus-stop-uncovered',
        title: 'Pasajeros y rutas',
        path: '/client/administracionPasajerosYViajes',
        role: '*',
        per: 'CK_PASAJEROS_LECTURA'
      },
      {
        icon: 'mdi-bus-multiple',
        title: 'Konect Van Empresarial',
        path: '/konectVan/viajes',
        role: '*',
        per: 'CK_VAN_EMPRESARIAL_VIAJES_LECTURA'
      },
      {
        icon: 'mdi-bus-marker',
        title: 'Ascensos',
        path: '/ascensos',
        role: '*',
        per: 'CK_REPORTE_PUB_ASC_LECTURA'
      },
      {
        icon: 'mdi-map-clock-outline',
        title: 'Mapa Operativo Regio Ruta',
        path: '/mapaRegioRuta',
        role: '*',
        per: 'CK_MAPA_RR_LECTURA'
      },
      {
        icon: 'mdi-clipboard-text-outline',
        title: 'Reporte Regio Ruta',
        path: '/reporteRegioRuta',
        role: '*',
        per: 'CK_REPORTE_RR_LECTURA'
      },
      {
        icon: 'mdi-clipboard-text-multiple-outline',
        title: 'Reporte Regio Ruta Extendido',
        path: '/reporteRegioRutaExtendido',
        role: '*',
        per: 'CK_REPORTE_RR_EXT_LECTURA'
      },
      {
        icon: 'mdi-clipboard-check-outline',
        title: 'Conciliación Regio Ruta',
        path: '/conciliacionRegioRuta',
        role: '*',
        per: 'CK_REPORTE_RR_CONCILIACION_LECTURA'
      },
      {
        icon: 'mdi-map-marker-path',
        title: 'Mapa Konect Van Empresarial',
        path: '/konectVan/mapa',
        role: '*',
        per: 'CK_VAN_EMPRESARIAL_MAPA_LECTURA'
      },
      {
        icon: 'mdi-qrcode-scan',
        title: 'Konect Van Offline',
        path: '/konectVan/VanOffline',
        role: '*',
        per: 'CK_VAN_OFFLINE_LECTURA'
      },
      { icon: 'mdi-account', title: 'Perfil', path: '', role: '*', per: 'CK_' }
    ]
  }),
  mounted() {
    if (this.isClienteDeparturesAuth) {
      this.havePermission = true
      return
    }

    this.check()

    if (this.$session.get('permisos').length > 0) {
      this.havePermission = true
    }
  },
  computed: {
    ...mapGetters('general', ['user']),
    isClienteDeparturesAuth() {
      return this.$route.name == 'clientDeparturesAuth'
    }
  },
  methods: {
    ...mapActions('general', ['newUser', 'clearData']),
    check() {
      let user = this.$session.get('usr')
      let roles = this.$session.get('rol')
      this.newUser({ usr_nm: user, perfil: roles })
    },
    checkPermissions(p) {
      let per = this.$session.get('permisos')
      if (per) {
        for (let i = 0; i < per.length; i++) {
          if (per[i].search(p) == 0) {
            return true
          }
        }
      }
      return false
    },
    logout() {
      this.loading = true
      if (this.$session.exists()) {
        let jwt = this.$session.get('jwt')
        let headers = {
          Authorization: 'Bearer ' + jwt
        }
        this.axios
          .post(services.routes.logout, null, { headers })
          .then(() => {
            this.$session.destroy()
            this.clearData()
            this.$router.push('/login')
          })
          .catch(() => {
            this.$session.destroy()
            this.clearData()
            this.$router.push('/login')
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.app-header {
  z-index: 99;
}

.app-sidemenu {
  z-index: 99;
}

.text-user {
  text-transform: none !important;
}

.ver {
  margin-left: 4px !important;
}

v-btn v-navigation-drawer:hover ~ v-btn {
  width: 2000px !important;
  /*O lo que quieras*/
  height: 2000px !important;
  /*O lo que quieras*/
}
</style>
